import { useCurrentTeamMemberContext } from "../../useCurrentTeamMemberContext";

export const useGetCurrentOrganizationId = () => {
  const teamMember = useCurrentTeamMemberContext();
  const organizationId =
    teamMember.organization_team_members[0].organization_id;
  return organizationId;
};
